import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import {filter, map, mergeMap} from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UserService } from '../../services/user.service';
import { MatToolbar } from '@angular/material/toolbar';
import { NgClass } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [MatToolbar, NgClass, MatButton]
})
export class FooterComponent implements OnInit {

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    ) { }

  version = environment.version;
  footerHomeClass = '';
  privacyPolicyLink: string = null;
  cookiePolicyLink: string = null;

  ngOnInit(): void {

    this.userService.getPublicDocuments((res: any) => {
      const documents = res?.documents || [];
      this.privacyPolicyLink = documents.find((d: any) => d.type === 'privacy policy')?.link || null;
      this.cookiePolicyLink = documents.find((d: any) => d.type === 'cookie policy')?.link || null;
    });


    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => route.data)
    )
      .subscribe((event) => {
        if(event['isHome'] || event['isErrorPage'] || event['isBootstrap']) {
          this.footerHomeClass = 'footer-home';
        } else {
          this.footerHomeClass = '';
        }
      });

  }



}
